var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notice" }, [
    _c(
      "div",
      { staticClass: "notice-wrap" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("Notice")]),
        _vm._v(" "),
        _vm._l(_vm.notice, function(item, index) {
          return _c("div", { key: index, staticClass: "contents row" }, [
            _c(
              "div",
              {
                staticClass: "header col-12",
                on: {
                  click: function($event) {
                    return _vm.noticeOpen(index)
                  }
                }
              },
              [
                _c("div", { staticClass: "seq" }, [
                  _vm._v(_vm._s(item.seq) + ".")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                !_vm.isMobile ? _c("div", { staticClass: "spacer" }) : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "date" }, [_vm._v(_vm._s(item.date))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "img", class: { isOpen: item.isOpen } },
                  [_c("img", { attrs: { src: _vm.closeImg } })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "body" },
              [
                _c("collapse-transition", [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.isOpen,
                        expression: "item.isOpen"
                      }
                    ],
                    domProps: { innerHTML: _vm._s(item.content) }
                  })
                ])
              ],
              1
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5de37029", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de37029","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Notice.vue
// module id = null
// module chunks = 